/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CommentContainerLocal = {
    readonly showCommentIDs: boolean | null;
    readonly " $refType": "CommentContainerLocal";
};
export type CommentContainerLocal$data = CommentContainerLocal;
export type CommentContainerLocal$key = {
    readonly " $data"?: CommentContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showCommentIDs",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '61e02028ec4d87225557ca8a8d8297de';
export default node;
